<template>
  <v-tooltip top color="primary">
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" small color="success" outline>
        {{ $t("screener.ended.title") }}
      </v-chip>
    </template>
    <span class="background--text body-1">{{
      $t("screener.ended.tooltip")
    }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "EndedIndicator"
};
</script>

<style>
</style>
